import nxModule from 'nxModule';
import ParameterizedLocalCache from 'shared/utils/parameterized-local-cache';

nxModule.factory('sweepCache', (http, CacheFactory, config) =>
  new ParameterizedLocalCache({
    provider: (accountId) => http.get(`/products/accounts/${accountId}/sweep`),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.sweep,
    cacheName: 'sweepCache'
  })
);
